module.exports = __webpack_public_path__ + "static/media/ic-trusted.1856f114.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ic-trusted.svg
// module id = 637
// module chunks = 8